import shareAPI from '../../../API/shareConfig'
import { errorHandler } from '../../../sharedComponents/src/globalHeader/functions/ams-functions'

export enum SHARE_TYPE {
    DAILY_PUZZLE = 'puzzle_daily',
    PUZZLE_QUEST = 'puzzle_quest',
}

interface ISharePuzzleFeedbackRequest {
    shareType: SHARE_TYPE
    performanceGroupID: number
    puzzleID: string
}

interface ISharePuzzleFeedbackResponse {
    shareURL: string
}

export const sharePuzzleFeedback = async (data: ISharePuzzleFeedbackRequest): Promise<ISharePuzzleFeedbackResponse> => {
    try {
        const response = await shareAPI.post(`/api/share/${data.shareType}`, {
            performanceGroupID: data.performanceGroupID,
            puzzleID: data.puzzleID,
        })
        return response.data
    } catch (error) {
        throw errorHandler(error)
    }
}